import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import NexusLayout from "@/pages/nexus/NexusLayout";
import NexusHome from "@/pages/nexus/Home";
import NexusListings from "@/pages/nexus/Listings";
import NexusListingDetail from "@/pages/nexus/ListingDetail";
import NexusSell from "@/pages/nexus/Sell";
import NexusBuySide from "@/pages/nexus/BuySide";
import NexusSignIn from "@/pages/nexus/SignIn";
import NexusRegister from "@/pages/nexus/Register";
import NexusAccount from "@/pages/nexus/Account";
import NexusAuthVerify from "@/pages/nexus/AuthVerify";
import NexusDeals from "@/pages/nexus/Deals";
import NexusDealDetail from "@/pages/nexus/DealDetail";
import NexusWatchlist from "@/pages/nexus/Watchlist";
import ToolsHub from "@/pages/tools/ToolsHub";
import ProfitToPocket from "@/pages/tools/ProfitToPocket";
import SetupEstimator from "@/pages/tools/SetupEstimator";
import ComplianceCalendar from "@/pages/tools/ComplianceCalendar";
import RelocationRoadmap from "@/pages/tools/RelocationRoadmap";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightDetail />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/tools" element={<ToolsHub />} />
              <Route path="/tools/profit-to-pocket" element={<ProfitToPocket />} />
              <Route path="/tools/company-setup-estimator" element={<SetupEstimator />} />
              <Route path="/tools/compliance-calendar" element={<ComplianceCalendar />} />
              <Route path="/tools/relocation-roadmap" element={<RelocationRoadmap />} />
            </Route>
            <Route path="/nexus" element={<NexusLayout />}>
              <Route index element={<NexusHome />} />
              <Route path="listings" element={<NexusListings />} />
              <Route path="listings/:slug" element={<NexusListingDetail />} />
              <Route path="sell" element={<NexusSell />} />
              <Route path="buy-side-request" element={<NexusBuySide />} />
              <Route path="signin" element={<NexusSignIn />} />
              <Route path="register" element={<NexusRegister />} />
              <Route path="account" element={<NexusAccount />} />
              <Route path="auth/verify" element={<NexusAuthVerify />} />
              <Route path="deals" element={<NexusDeals />} />
              <Route path="deals/:id" element={<NexusDealDetail />} />
              <Route path="watchlist" element={<NexusWatchlist />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0c0e12",
              border: "1px solid rgba(255,255,255,0.08)",
              color: "#f2f0ed",
              fontFamily: "Inter Tight, sans-serif",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
